/**
 * Service: paymentProcessor
 */
angular.module('acme.common.service.paymentProcessor', [])
.service('PaymentProcessorService', ['$q', '$timeout', function($q, $timeout) {

    return {

      model: {},
      card: {
        number: '',
        cvc: '',
        exp_month: '',
        exp_year: '',
        zip: ''
      },

      address: {
        streetAddress1: '',
        streetAddress2: '',
        country: '',
        city: '',
        state: '',
        zip: ''
      },

      fields:  {
        number: 'cc-number',
        cvc: 'cc-cvc',
        exp_month: 'cc-month',
        exp_year: 'cc-year',
        streetAddress1: 'streetAddress1',
        streetAddress2: 'streetAddress2',
        country: 'country',
        city: 'city',
        state: 'state',
        zip: 'zip',
        address: 'address',
        errors: {
          number: 'Invalid credit card number',
          cvc: 'Invalid CVC code',
          exp_month: 'Invalid expire month',
          exp_year: 'Invalid expire year',
          streetAddress1: 'Invalid street address',
          country: 'Invalid country',
          city: 'Invalid city',
          state: 'Invalid state',
          zip: 'Invalid zip/postal code',
          address: 'Invalid address'
        }
      },

      CODES: {
        errors: {
          INVALID_NUMBER: 6100,       // "The card number is not a valid credit card number"
          INVALID_EXPIRY_MONTH: 6101, // "The card's expiration month is invalid"
          INVALID_EXPIRY_YEAR: 6102,  // "The card's expiration year is invalid"
          INVALID_CVC: 6103,          // "The card's security code is invalid"
          INCORRECT_NUMBER: 6104,     // "The card number is incorrect"
          EXPIRED_CARD: 6105,         // "The card has expired"
          INCORRECT_CVC: 6106,        // "The card's security code is incorrect"
          INCORRECT_ZIP: 6107,        // "The card's zip code failed validation"
          INCORRECT_ADDRESS: 6113,    // "The card's address verification failed validation"
          CARD_DECLINED: 6108,        // "The card was declined"
          MISSING: 6109,              // "There is no card on a customer that is being charged"
          PROCESSING_ERROR: 6110,     // "An error occurred while processing the card"
          STREET_ADDRESS1_REQUIRED: 5082, // "The card's street address is missing"
          CITY_REQUIRED: 5083,            // "The card's street city is missing"
          STATE_REQUIRED: 5084,           // "The card's state is missing"
          ZIP_REQUIRED: 5085,             // "The card's zip code is missing"
          COUNTRY_REQUIRED: 5086          // "The card's country is missing"
        },

        find: function(code) {
          var type,
            r = false,
            _code = parseInt(code, 10);

          if (!isNaN(_code)) {
            for (type in this.errors) {
              if (this.errors.hasOwnProperty(type) && this.errors[type] === _code) {
                r = {
                  type: type,
                  code: this.errors[type]
                };
                break;
              }
            }
          }

          return r;
        }

      },

      q: false,

      init: function() {
        return true;
      },

      clear: function() {
        this.card.number = '';
        this.card.cvc = '';
        this.card.exp_month = '';
        this.card.exp_year = '';
        this.card.address = '';
        this.card.zip = '';
        this.model = {};
      },

      process: function() {
        var self = this;

        this.q = $q.defer();

        this.model = {
          cvc: this.card.cvc,
          number: this.card.number,
          exp_month: this.card.exp_month,
          exp_year: this.card.exp_year,
          address: this.card.address,
          zip: this.card.zip,
          acmeToken: this.generateToken(),
          ccLastFourDigits: this.card.number.substr(this.card.number.length - 4, 4)
        };

        // next tick
        $timeout(function() {
          // Respond like a normal API for consistency
          self.q.resolve({ data: { payload: self.model } });
        }, 0);

        return this.q.promise;

      },

      generateToken: function() {

        var cc = this.card.number.replace(/ /g,''),
            first = cc.substr(0, 6),
            last = cc.substr(cc.length - 4, 4);

        return first + last;

      },

      mapError: function(code) {

        var validators = [],
            e = this.CODES.find(code);

        switch(e.type) {
          case 'MISSING':
          case 'EXPIRED_CARD':
          case 'CARD_DECLINED':
          case 'INVALID_NUMBER':
          case 'INCORRECT_NUMBER':
          case 'PROCESSING_ERROR':
            validators.push({ field: this.fields.number, len: { message: 'Please enter a valid credit card number', test: { value: '' } } });
            break;
          case 'INVALID_CVC':
          case 'INCORRECT_CVC':
            validators.push({ field: this.fields.cvc, len: { message: 'Invalid CVC code', test: { value: '' } } });
            break;
          case 'INVALID_EXPIRY_MONTH':
            validators.push({ field: this.fields.exp_month, len: { message: 'Please enter a valid expiration month', test: { value: '' } } });
            break;
          case 'INVALID_EXPIRY_YEAR':
            validators.push({ field: this.fields.exp_year, len: { message: 'Please enter a valid expiration year', test: { value: '' } } });
            break;
          case 'INCORRECT_ADDRESS':
            validators.push({ field: this.fields.address, len: { message: 'Address verification failed', test: { value: '' } } });
            break;
          case 'INCORRECT_ZIP':
            validators.push({ field: this.fields.zip, len: { message: 'Zip code failed verification', test: { value: '' } } });
            break;
        }

        return validators;

      },

      success: {
        response: function(response, status) {
          console.log('PaymentProcessor::success::response', this, response);
        }
      },

      error: {
        response: function(response, status) {
          console.log('PaymentProcessor::error::response', this, response);
        }
      }

    };

}]);